module.exports = __webpack_public_path__ + "static/media/ring.ac2414a9.ogg";